import React, { useState, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { selectLocale } from 'models/localization';
import findAvailableLocale from 'models/helpers/findAvailableLocale';
import { useSelector } from 'react-redux';

import DesktopAppBar from './DesktopAppBar';
import MobileAppBar from './MobileAppBar';

export default function XtraAppBar({
  hideSearchBar, hideUser, hideDrawer,
}) {
  const locale = useSelector(selectLocale);
  const isDesktop = useMediaQuery('(min-width: 960px)');
  const [bookmarksModalOpen, setBookmarksModalOpen] = useState(false);
  const { logos = [] } = useSelector((s) => s.eventConfigs);
  const openBookmarks = useCallback(() => {
    // if there have new enter point please let allen know.
    window.trackingEventToFirebase(null, 'MainMenu_Click', 'Bookmark', '');
    setBookmarksModalOpen(true);
  }, []);

  const closeBookmarks = useCallback(() => {
    setBookmarksModalOpen(false);
  }, []);

  const logoList = useMemo(
    () => {
      if (Array.isArray(logos)) {
        return logos.map((it) => ({
          height: it.height || 40,
          src: findAvailableLocale(it.src || {}, locale),
          redirectUrl: findAvailableLocale(it.redirectUrl || {}, locale),
          redirectExternal: !!it.redirectExternal,
        }));
      }

      const height = logos?.logoHeight !== undefined ? logos.logoHeight : 40;
      const preHandledList = logos?.logoList || [];
      const list = Array.isArray(preHandledList)
        ? preHandledList
        : findAvailableLocale(preHandledList || {}, locale) || [];

      return list.map((src) => ({
        height,
        src,
        redirectUrl: null,
        redirectExternal: false,
      }));
    },
    [locale, logos],
  );

  return isDesktop ? (
    <DesktopAppBar
      logos={logoList}
      hideSearchBar={hideSearchBar}
      hideUser={hideUser}
      bookmarksModalOpen={bookmarksModalOpen}
      openBookmarks={openBookmarks}
      closeBookmarks={closeBookmarks}
    />
  ) : (
    <MobileAppBar
      logos={logoList}
      hideSearchBar={hideSearchBar}
      hideDrawer={hideDrawer}
      bookmarksModalOpen={bookmarksModalOpen}
      openBookmarks={openBookmarks}
      closeBookmarks={closeBookmarks}
    />
  );
}

XtraAppBar.propTypes = {
  hideSearchBar: PropTypes.bool,
  hideUser: PropTypes.bool,
  hideDrawer: PropTypes.bool,
};

XtraAppBar.defaultProps = {
  hideSearchBar: false,
  hideUser: false,
  hideDrawer: false,
};
